module.exports = __webpack_public_path__ + "img/start.3b78b78c.svg";